import { useEffect, useState } from "react";
import { Flame } from "lucide-react";

const KEY = "tha_age_ok_v1";

const AgeGate = () => {
  const [open, setOpen] = useState(false);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    const ok = localStorage.getItem(KEY);
    if (!ok) setOpen(true);
  }, []);

  const confirm = () => {
    localStorage.setItem(KEY, "1");
    setOpen(false);
  };

  if (!open && !denied) return null;

  return (
    <div
      data-testid="age-gate-overlay"
      className="fixed inset-0 z-[100] flex items-center justify-center px-4"
      style={{
        background: "rgba(0,0,0,0.92)",
        backdropFilter: "blur(18px)",
      }}
    >
      <div className="grain-overlay" />
      <div
        className="relative w-full max-w-xl border border-[var(--tha-border)] bg-[#0a0a0a] p-8 sm:p-12 rise"
        data-testid="age-gate-modal"
      >
        <div className="flex items-center gap-3 text-xs font-mono-x tracking-widest text-[var(--tha-muted)]">
          <Flame size={14} className="text-[var(--tha-red)]" />
          TIK HEM AAN! — LEEFTIJDSCHECK
        </div>

        <h2 className="font-display text-5xl sm:text-7xl mt-6 text-white leading-none">
          BEN JIJ <span className="neon-red-text">18+</span>?
        </h2>

        <p className="mt-6 text-[var(--tha-muted)] text-sm sm:text-base leading-relaxed max-w-md">
          Deze website bevat content over alcoholische dranken. Je moet 18 jaar of ouder
          zijn om binnen te komen. Geen ID? Geen shots.
        </p>

        {denied ? (
          <div
            data-testid="age-gate-denied"
            className="mt-8 border border-[var(--tha-border)] p-5 text-sm text-[var(--tha-muted)]"
          >
            Sorry, je moet 18+ zijn om deze site te bezoeken. Kom later terug — wij gaan
            nergens heen.
          </div>
        ) : (
          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <button
              data-testid="age-gate-yes-button"
              onClick={confirm}
              className="btn-red px-8 py-4 font-display tracking-wide text-base sm:text-lg"
            >
              JA, IK BEN 18+
            </button>
            <button
              data-testid="age-gate-no-button"
              onClick={() => {
                // Hard-block underage visitors: redirect away from the site.
                // Marked denied first for the brief moment before the redirect.
                setDenied(true);
                try {
                  window.location.replace("https://www.google.com");
                } catch {
                  window.location.href = "https://www.google.com";
                }
              }}
              className="btn-ghost-red px-8 py-4 font-display tracking-wide text-base sm:text-lg"
            >
              NEE, NOG NIET
            </button>
          </div>
        )}

        <p className="mt-8 text-[10px] text-[var(--tha-dim)] tracking-widest uppercase">
          Geniet, maar drink met mate. NIX18.
        </p>
      </div>
    </div>
  );
};

export default AgeGate;
